import React from 'react'
import { createContainer } from '@dbk-legacy/muster/react'
import Modal from '../../common/modal'
import Button from '@dbk/ui-buttons';
import envconfig from '../../../../db-env-build';
import { EBANKINGWEBLUX } from '../../../constants'
import config from '../../../data/get-settings'
import LoadingCircle from '../../common/loading/loading-circle';
import { KEY_CODE } from '../../../constants';

class Discovery extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      index: 0, // no images will be displayed
    }
  }

  changeIndex = (i, length, e) => {
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
      if ((i > 0 && this.state.index < length - 1) || (i < 0 && this.state.index > 1)) {
        this.setState(prevState => ({
          ...prevState,
          index: prevState.index + i
        }))
      }
    }
  }
  onDone = (e) => {
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
      this.setState(prevState => ({
        ...prevState,
        index: 0
      }))
      this.props.discovery.new()
    }
  }

  componentDidMount() {
    this.props.discovery.init();
    this.props.discovery.verify();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.discovery.verifyPath !== prevProps.discovery.verifyPath) {
      this.props.discovery.verify();
    }
    if(document.querySelector('.bg-img')){
      document.querySelector('.bg-img').focus();
    }
  }

  handleGetStarted = (imgCount) => {
    this.changeIndex(1, imgCount)
  }

  getImageLabel(imageUrl){
    const { i18n: { messages } } = this.props;
    if(imageUrl.includes("welcome")){
      return messages['app.discovery.welcomeMessage'];
    }
    else if(imageUrl.includes("portfolio")){
      return messages['app.discovery.portfolio'];
    }
    else if(imageUrl.includes("maturities")){
      return messages['app.discovery.maturities'];
    }
    else if(imageUrl.includes("reports")){
      return messages['app.discovery.reports'];
    }
    else if(imageUrl.includes("payments")){
      return messages['app.discovery.payments'];
    }
    else if(imageUrl.includes("settings")){
      return messages['app.discovery.settings'];
    }
    else if(imageUrl.includes("search")){
      return messages['app.discovery.search'];
    }
    else if(imageUrl.includes("notifications")){
      return messages['app.discovery.notifications'];
    }
    else if(imageUrl.includes("consolidation")){
      return messages['app.discovery.consolidation'];
    }
    else if(imageUrl.includes("contact")){
      return messages['app.discovery.contact'];
    }
  }

  render() {
    if (this.props.discovery.validate) {
      this.props.discovery.verify();
    }
    const regionCode = this.props.config && this.props.config.regionCode.toLowerCase();
    const isSmall = this.props.screen && this.props.screen.isSmall;
    const discoveryImageUrls = this.props.discovery.imageUrls;
    let imageUrls = discoveryImageUrls[isSmall ? 'small' : 'large'];
    imageUrls = envconfig.envConfig === EBANKINGWEBLUX ? imageUrls && imageUrls.filter(item => !item.includes('payments.jpg') && !item.includes('contact.jpg')) : imageUrls;
    const imgCount = imageUrls && imageUrls.length;
    
    // In DWO 2.0 supports only english helpscreens
    const languageCode = 'en'
    const image = imageUrls && languageCode + '_' + imageUrls[this.state.index];
    const { i18n: { messages } } = this.props;
    const webFolder = config.webfolder == '' ? config.webfolder : "/" + config.webfolder;
    return this.props.discovery.visible && imgCount ? (
      <Modal>
        <div className='modal abs-full flex flex-jc-center flex-ai-center'>
          <div className='bg-img bg-img-contain abs-full trans-5'
            style={{ backgroundImage: `url(${webFolder}/images/${regionCode}/${image})` }}
            onClick={() => this.changeIndex(1, imgCount)} 
            tabIndex={0}
            aria-label={this.getImageLabel(imageUrls && imageUrls[this.state.index])}
            />
          {this.state.index === 0 ?
            window.location.pathname !== "/reports" && <Button
              size="large"
              className="btn-discovery trans-5"
              onClick={() => this.handleGetStarted(imgCount)}>
              {messages['app.discovery.getStarted']}
            </Button> :
            <div className="btn btn-default modal-close"
              onClick={() => this.onDone()}
              onKeyDown={(e)=> this.onDone(e)}
              tabIndex={0}
              role="button">
              {messages['app.discovery.compelete']}
            </div>}
          {this.state.index > 1 && this.state.index < imgCount &&
            <i className='i-arrow i-arrow-left trans-5' onClick={() => this.changeIndex(-1, imgCount)} onKeyDown={(e) => this.changeIndex(-1, imgCount, e)} tabIndex={0} aria-label={messages['app.assets.previousButton']} role="button"/>}
          {this.state.index < imgCount - 1 ?
            <i className='i-arrow i-arrow-right trans-5' onClick={() => this.changeIndex(1, imgCount)} onKeyDown={(e) => this.changeIndex(1, imgCount, e)} tabIndex={0} aria-label={messages['app.rsa.nextText']} role="button"/> :
            <Button
              size="large"
              className="btn-discovery-complete trans-5"
              onClick={() => this.onDone()}>
              {messages['app.discovery.compelete']}
            </Button>
          }
          <div className='loading-circle'><LoadingCircle /></div>
        </div>
      </Modal>
    ) : null
  }
}

// export default Discovery
export default createContainer({
  $renderLoading: () => <LoadingCircle />,
  $queries: {
    // discoveryInit: { $call: 'discovery.init' },
    // discoveryVerify: { $call: 'discovery.verify' },
    // discoveryNew: { $call: 'discovery.new' },
    discovery: {
      verify: { $call: 'verify' },
      new: { $call: 'new' },
      init: { $call: 'init' },
      verifyPath: true,
      visible: true,
      imageUrls: true,
      currentDiscoveryID: true,
      validate: true
    },
    ui: {
      history: {
        currentLocation: {
          pathname: true
        }
      }
    },
    screen: {
      width: true,
      isSmall: true
    },
    i18n: {
      messages: true,
    },
    config: {
      regionCode: true,
    },
  }
})(Discovery)
